/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  casos: [],
  total_casos: 0,
  meta: [
    { title: 'CÓDIGO', sortKey: 'id' },
    { title: 'DESCRIPCIÓN', sortKey: 'descripcion' },
    { title: 'PROYECTO', sortKey: '' },
    { title: 'SUBPROYECTO', sortKey: '' },
    { title: 'TIPO CASO', sortKey: '' },
    { title: 'FECHA REGISTRO', sortKey: 'fechaAcordada' },
    { title: 'FECHA FINALIZACION', sortKey: 'fechaRealFin' },
    { title: 'ESTADO', sortKey: 'descRequestStatus' },
    { title: 'ÁREA', sortKey: '' },
    { title: 'USUARIO', sortKey: 'nameUser' },
    { title: 'ACCIONES', sortKey: '' }
  ]
  // meta: [
  //   {name: 'CÓDIGO', object: 'id'},
  //   {name: 'DESCRIPCIÓN', object: 'descripcion'},
  //   {name: 'FECHA COMPROMISO', object: 'fechaAcordada'},
  //   {name: 'COMPAÑIA', object: 'compañia', subObject: 'descripcion'},
  //   {name: 'PROYECTO', object: 'proyecto', subObject: 'descripcion'},
  //   {name: 'TIPO CASO', object: 'tipoActividad', subObject: 'descripcion'},
  //   {name: 'ESTADO', object: 'estado'}
  // ]
}
